import {
	SentimentDissatisfiedOutlined,
	SentimentNeutralOutlined,
	SentimentSatisfiedOutlined,
	SentimentVeryDissatisfiedOutlined,
	SentimentVerySatisfiedOutlined,
} from '@mui/icons-material';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type SatisfactionsCheckListProps = Readonly<{
	value: readonly string[];
	onChange(newTags: readonly string[]): void;
	loading?: boolean;
}>;

const ICON_SIZE = {
	width: '48px',
	height: '48px',
};

export const SatisfactionsCheckList: FC<SatisfactionsCheckListProps> = ({ value, onChange, loading }) => {
	const theme = useTheme();

	const satisfactions = [
		{ id: '0', icon: <SentimentVeryDissatisfiedOutlined sx={{ color: theme.palette.dustred[300], ...ICON_SIZE }} /> },
		{ id: '25', icon: <SentimentDissatisfiedOutlined sx={{ color: theme.palette.orange[300], ...ICON_SIZE }} /> },
		{ id: '50', icon: <SentimentNeutralOutlined sx={{ color: theme.palette.grey[500], ...ICON_SIZE }} /> },
		{ id: '75', icon: <SentimentSatisfiedOutlined sx={{ color: theme.palette.green[300], ...ICON_SIZE }} /> },
		{ id: '100', icon: <SentimentVerySatisfiedOutlined sx={{ color: theme.palette.green[500], ...ICON_SIZE }} /> },
	];

	const selectedSatisfactions = value.filter((value) => satisfactions.some((o) => o.id === value));

	if (loading) {
		return (
			<Typography sx={{ color: theme.palette.secondary.main }}>
				<FormattedMessage id={'common.loading'} />
			</Typography>
		);
	}

	return (
		<Stack direction={'column'} gap={2}>
			{satisfactions.length > 0 && (
				<Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
					{satisfactions.map((satisfaction) => (
						<Box
							key={satisfaction.id}
							onClick={() =>
								selectedSatisfactions.includes(satisfaction.id)
									? onChange(selectedSatisfactions.filter((pId) => pId !== satisfaction.id))
									: onChange(selectedSatisfactions.concat(satisfaction.id))
							}
							sx={{
								cursor: 'pointer',
								opacity: selectedSatisfactions.includes(satisfaction.id) ? 1 : 0.3,
							}}
						>
							{satisfaction.icon}
						</Box>
					))}
				</Box>
			)}
		</Stack>
	);
};
